import { memo } from "react";
import { Button, Col, Form, Input, Row, Select, Space, Typography } from "antd";
import {  SaveOutlined, UserOutlined } from "@ant-design/icons";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

const { Title, Text } = Typography;


function ProfileDetailsTabComponent({
  form,
  editMode,
  saving,
  sessionProfile,
  securityQuestions,
  securityQuestionsLoading,
  onEdit,
  onCancel,
  onSave,
}) {
  const securityQuestionOptions = securityQuestions.map((item) => ({
    value: String(item.quesId),
    label: item.question,
  }));

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
        <div>
          <Title level={5} style={{ margin: 0 }}>
            Personal Information
          </Title>
          <Text style={{ color: "#8c8c8c", fontSize: 13 }}>Update your personal and professional details</Text>
        </div>
        {!editMode ? (
          <Button icon={<EditOutlinedIcon style={{ fontSize: 15 }} />} onClick={onEdit}>
            Edit Profile
          </Button>
        ) : (
          <Space>
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" icon={<SaveOutlined />} loading={saving} onClick={onSave}>
              Save Changes
            </Button>
          </Space>
        )}
      </div>

      <Form
        form={form}
        layout="vertical"
        disabled={!editMode}
        initialValues={{
          firstName: sessionProfile.firstName,
          lastName: sessionProfile.lastName,
          email: sessionProfile.email,
          department: sessionProfile.role,
          employeeId: sessionProfile.userId,
          questionId: sessionProfile.questionId || undefined,
          securityAnswer: sessionProfile.securityAnswer,
        }}
      >
        <Row gutter={[16, 0]}>
          <Col xs={24} md={12}>
            <Form.Item
              label="First Name"
              name="firstName"
              rules={[
                { required: true, message: "Required" },
                { pattern: /^[A-Za-z]+$/, message: "First name must contain letters only" },
              ]}
            >
              <Input prefix={<UserOutlined style={{ color: "#bfbfbf" }} />} size="large" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="Last Name"
              name="lastName"
              rules={[
                { required: true, message: "Required" },
                { pattern: /^[A-Za-z\s]+$/, message: "Last name must contain letters only" },
              ]}
            >
              <Input size="large" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item label="Role" name="department">
              <Input size="large" disabled />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item label="UST UID" name="employeeId">
              <Input size="large" disabled />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="Security Question"
              name="questionId"
              rules={[{ required: true, message: "Please select a security question" }]}
            >
              <Select
                size="large"
                placeholder="Select security question"
                loading={securityQuestionsLoading}
                options={securityQuestionOptions}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="Security Answer"
              name="securityAnswer"
              rules={[
                { required: true, message: "Please enter security answer" },
                { whitespace: true, message: "Security answer cannot be empty" },
              ]}
            >
              <Input size="large" placeholder="Enter security answer" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export const ProfileDetailsTab = memo(ProfileDetailsTabComponent);
